import { api } from '../hooks/useConfigureAxios';

export type ProfileParams = {
  tickets?: {
    deviceId: string;
    ticketNumber: string;
  }[];
  from?: string;
  to?: string;
  fields?: string[];
  aggregateWindowInSeconds?: number;
  format?: 1 | 2;
  barges?: string[];
};

export const ProfileAPI = {
  getProfile: async function ({ params }: { params?: any }) {
    const response = await api.request({
      url: `/data-logger/mfm/Profile`,
      method: 'GET',
      params,
    });

    return response.data;
  },
};
